/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { PlatformCompanyRegistrationDto } from './platform-company-registration-dto.model';
import { PlatformLegalEntityAddressDto } from './platform-legal-entity-address.dto';
import { PlatformLegalEntityBankAccountDto } from './platform-legal-entity-bank-account-dto.model';
import { PlatformLegalEntityInvoicingTermsDto } from './platform-legal-entity-invoicing-terms-dto.model';

export class PlatformLegalEntityDTO extends JSONable{
  uuid: string | null = null;
  companyRegistrationDTO: PlatformCompanyRegistrationDto | null = null;
  addressDTO: PlatformLegalEntityAddressDto | null = null;
  bankAccountDTO: PlatformLegalEntityBankAccountDto | null = null;
  invoicingTermsDTO: PlatformLegalEntityInvoicingTermsDto | null = null;

  constructor() {
    super();

    this.companyRegistrationDTO = new PlatformCompanyRegistrationDto();
    this.addressDTO = new PlatformLegalEntityAddressDto();
    this.bankAccountDTO = new PlatformLegalEntityBankAccountDto();
    this.invoicingTermsDTO = new PlatformLegalEntityInvoicingTermsDto();
  }
}
